import { format } from 'date-fns';
import type { Academy } from '@court-sync/shared';
import type { DayCourtReschedulePayload } from '@/components/schedule/DayCourtScheduleView';
import { isSessionDateBeforeAcademyToday } from './academyCalendarDate';

export function getSessionRescheduleConfirmMeta(
  payload: DayCourtReschedulePayload,
  academy: Pick<Academy, 'timezone'> | null | undefined
): {
  timeChanged: boolean;
  requireReason: boolean;
  needsConfirmDialog: boolean;
} {
  const timeChanged =
    payload.startTime !== payload.occurrence.startTime ||
    payload.endTime !== payload.occurrence.endTime;
  const sessionDateYmd = format(payload.occurrence.date, 'yyyy-MM-dd');
  const requireReason = isSessionDateBeforeAcademyToday(sessionDateYmd, academy);
  return {
    timeChanged,
    requireReason,
    needsConfirmDialog: timeChanged || requireReason,
  };
}
